var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"mb-3 mt-3",attrs:{"center":"","src":require("@/assets/images/logo/CuidoLogo.png"),"height":"57.5px"}})}
var staticRenderFns = []

export { render, staticRenderFns }